// src/api/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://api.turkcedunyasi.com/", // Backend API BASE URL
  timeout: 10000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

// 📌 Request Interceptor (JWT Token otomatik ekler)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 📌 Response Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Token expired → logout
    if (error.response?.status === 401 && !error.config.url.includes('adminLogin')) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
